import { Avatar, AvatarProps } from "@/components/Common/Avatar";
import { IconNames, User } from "@/types/v2";
import { getUsersInitials } from "@/lib/users";
import { Icon } from "@/components/Common/Icon";

interface UserAvatarProps extends AvatarProps {
  user?: User;
  fallbackSize?: number;
}
export const UserAvatar = ({
  user,
  fallbackSize = 16,
  ...props
}: UserAvatarProps) => {
  return (
    <Avatar
      src={user?.profileImage}
      fallback={
        user?.displayName ? (
          getUsersInitials(user?.displayName)
        ) : (
          <Icon name={IconNames.user} size={fallbackSize} />
        )
      }
      bgColor={user?.profileColor}
      {...props}
    />
  );
};
